export enum SecurityScope {
    Master = 'master',
    AdminRemoveAccount = 'adminRemoveAccount'
}



// WEBPACK FOOTER //
// ./src/backoffice/utils/SecurityScope.ts